import { Route, Routes } from 'react-router-dom';

import { FC } from 'react';
import ForgottenPassword from './forgotten-password';
import Login from './login';
import NotFound from '../not-found';
import PasswordChanged from './password-changed';
import ResetPassword from './reset-password';
import SignupPage from './signup';
import VerificationEmailSent from './verification-email-sent';
import VerifyEmail from './verify-email';

const AuthenticationRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgotten-password" element={<ForgottenPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/password-changed" element={<PasswordChanged />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route
        path="/verification-email-sent"
        element={<VerificationEmailSent />}
      />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default AuthenticationRoutes;
